import type { SVGProps } from 'react';
import * as React from 'react';
import { Ref, forwardRef, memo } from 'react';

interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
  stroke?: string;
  logoColor?: string;
}

const SvgSuperbarDark = (
  {
    title,
    titleId,
    desc,
    descId,
    stroke = '#fff',
    logoColor = '#111',
    ...props
  }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    fill="none"
    viewBox="0 0 27 27"
    role="img"
    ref={ref}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={stroke}
      d="M22.497 0c2.3 0 4.166 1.865 4.166 4.166v18.33c0 2.302-1.865 4.167-4.166 4.167H4.167A4.166 4.166 0 0 1 0 22.497V4.166C0 1.866 1.865 0 4.166 0z"
    />
    <path
      fill={logoColor}
      d="M11.873 8.332h7.915c.576 0 1.042.466 1.042 1.041v2.916c0 .576-.466 1.042-1.042 1.042h-2.916c-.575 0-1.041.466-1.041 1.041v2.917c0 .575-.467 1.041-1.042 1.041H6.874a1.04 1.04 0 0 1-1.042-1.041v-2.917c0-.575.466-1.041 1.042-1.041H9.79c.575 0 1.041-.466 1.041-1.042V9.373c0-.575.467-1.041 1.042-1.041"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSuperbarDark);
const Memo = memo(ForwardRef);
export default Memo;
